export default __webpack_public_path__ + "static/media/3.deb1223e.png";